import React from "react";
import {
  CheckCircleOutlined,
  GiftOutlined,
  MessageOutlined,
  ReadOutlined,
  ShoppingCartOutlined,
  TrophyOutlined,
} from "@ant-design/icons";
import lotteryPostTemplate from "../../../assets/lottery-post.png";

const LOTTERY_POSTER_TEMPLATE_SIZE = {
  width: 3543,
  height: 13848,
};

const LOTTERY_POSTER_QR_SLOT = {
  x: 2019,
  y: 1768,
  size: 1027,
  padding: -80,
};

function loadImage(src) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = reject;
    image.src = src;
  });
}

export async function composeLotterySharePoster(qrCode, scale = 1) {
  const [posterImage, qrImage] = await Promise.all([
    loadImage(lotteryPostTemplate),
    loadImage(`data:image/png;base64,${qrCode}`),
  ]);
  const posterWidth = posterImage.naturalWidth;
  const posterHeight = posterImage.naturalHeight;
  const canvas = document.createElement("canvas");
  canvas.width = Math.round(posterWidth * scale);
  canvas.height = Math.round(posterHeight * scale);
  const context = canvas.getContext("2d");
  const slotScaleX = posterWidth / LOTTERY_POSTER_TEMPLATE_SIZE.width;
  const slotScaleY = posterHeight / LOTTERY_POSTER_TEMPLATE_SIZE.height;
  const qrLeft = LOTTERY_POSTER_QR_SLOT.x * slotScaleX * scale;
  const qrTop = LOTTERY_POSTER_QR_SLOT.y * slotScaleY * scale;
  const qrSize = LOTTERY_POSTER_QR_SLOT.size * slotScaleX * scale;
  const qrPadding = LOTTERY_POSTER_QR_SLOT.padding * slotScaleX * scale;
  const qrInnerSize = qrSize - qrPadding * 2;

  context.drawImage(posterImage, 0, 0, canvas.width, canvas.height);
  context.imageSmoothingEnabled = false;
  context.drawImage(
    qrImage,
    0,
    0,
    qrImage.naturalWidth || qrImage.width,
    qrImage.naturalHeight || qrImage.height,
    qrLeft + qrPadding,
    qrTop + qrPadding,
    qrInnerSize,
    qrInnerSize
  );

  return canvas;
}

export function getLotteryRewardIcon(iconKey) {
  switch (iconKey) {
    case "gift":
      return <GiftOutlined />;
    case "shopping":
      return <ShoppingCartOutlined />;
    case "message":
      return <MessageOutlined />;
    case "read":
      return <ReadOutlined />;
    case "check":
      return <CheckCircleOutlined />;
    case "trophy":
    default:
      return <TrophyOutlined />;
  }
}

function getLotteryPrizeAmount(name) {
  const match = String(name || "").match(/\d+/);
  return match ? Number(match[0]) : 0;
}

export function getLotteryPrizeAction(prize) {
  if (!prize) {
    return {
      text: "查看我的奖品",
      link: "/user/center/my-gifts",
    };
  }

  if (prize.type === "points") {
    const points = prize.grant?.points || getLotteryPrizeAmount(prize.name);
    const before = prize.grant?.before || {};
    const after = prize.grant?.after || {};
    const params = new URLSearchParams({
      lottery_points: String(points || 0),
      from_level: String(before.level || ""),
      from_left_points: String(before.left_points || ""),
      from_level_points: String(before.level_points || ""),
      to_level: String(after.level || ""),
      to_left_points: String(after.left_points || ""),
    });

    return {
      text: "查看我的权益",
      link: `/user/center/my-rights?${params.toString()}`,
    };
  }

  if (["live_coupon", "column_coupon", "coupon"].includes(prize.type)) {
    return {
      text: "查看我的优惠券",
      link: "/user/center/my-coupons?tab=lottery_records",
    };
  }

  return {
    text: "查看我的奖品",
    link: "/user/center/my-gifts",
  };
}
